import React, { useEffect, useState } from "react";
import Alerts from "../../../Popups/SidePopup";
import Loader from "../../../../../../presentationals/Loader/Loader.component";
import { deleteChallenge, getChallenges, saveChallenge } from "../../CommunityActionCreator";
import { paginationFuction } from '../../../CommonUtils';
import PaginationPage from "../../TablePagination";
import DeletePopup from "../../deletePopup";

const Challenges = (rowData) => {

    const [loaderState, setLoaderState] = useState(false)
    const [alertState, setAlertState] = useState(false)
    const [objectData, setObjectData] = useState({})
    const [deletePopupState, setDeletePopupState]= useState(false)
    const [allData, setAllData] = useState()
    const [msg, setMsg] = useState("")
    const [message, setMessage] = useState("")
    const [totalCount, setTotalCount] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [idToDelete, setIdToDelete] = useState(0)
    const [noOfRows, setNoOfRows] = useState(10)


    useEffect(() => {
        if (rowData) {
            getAllData(rowData.rowData.loanId, pageNumber, noOfRows)
        }
    }, [])

    const inputChange = (e) => {
        let changeData = Object.assign({}, objectData)
        changeData.description = e.target.value;
        setObjectData(changeData)
    }
    const paginationHandler = (pageNo, rows) => {
        setPageNumber(pageNo)
        setNoOfRows(rows)
        getAllData(rowData.rowData.loanId, pageNo, rows)
    }

    const paginationHandlerNew = (type, pageNumber) => {
        paginationFuction(type, pageNumber, totalCount, callBack => {

            setPageNumber(callBack)
            getAllData(rowData.rowData.loanId, callBack, noOfRows)
        })

    }
    const saveHandler = (type, data) => {
        if (type === "save") {
            setLoaderState(true)
            if (objectData && objectData.description) {
                setMessage("")
                objectData.loanId = rowData.rowData.loanId
                saveChallenge(objectData, callback => {
                    setAlertState(true)
                    setMsg("Challenge Saved!!")
                    removePopup()
                    getAllData(rowData.rowData.loanId, pageNumber, noOfRows)
                    objectData.description = ''
                    objectData.id = 0
                    setObjectData(objectData)
                    setLoaderState(false)
                }, error => {
                    setLoaderState(false)

                })
            } else {
                setMessage("Please enter description ")
                setLoaderState(false)

            }
        }
        if (type === "edit") {
            setLoaderState(true)
            setObjectData(data)
            setLoaderState(false)
        }
        if (type === "delete") {
            setIdToDelete(data)
            setDeletePopupState(true)
        }
    }

    const deleteHandler = (e) => {
        if (e === 'yes') {
            deleteChallenge(idToDelete,
                callBack => {
                    if (callBack.message === 'success') {
                        getAllData(rowData.rowData.loanId, pageNumber, noOfRows)
                        setDeletePopupState(false)
                        setAlertState(true)
                        setMsg("Deleted SuccessFully!!")
                        removePopup()
                    }
                }, error => {

                })
        } else {

        }
        setDeletePopupState(false)
    }

    const removePopup = () => {
        setTimeout(
            function () {
                setAlertState(false)
            }.bind(this),
            5000
        );
    }

    const getAllData = (loanId, pageNo, rows) => {
        const data = {
            loanId: loanId,
            pageNo: pageNo,
            noOfEntry: rows
        }
        setLoaderState(true)
        getChallenges(data, callback => {
            if (callback) {
                setAllData(callback.data)
            }
            setLoaderState(false)

        }, error => {
            setLoaderState(false)
        })

    }

    return (
        <div className='container-fluid'>
            {loaderState ?
                <Loader />
                : null}
            {deletePopupState ?
                <DeletePopup
                    deleteHandler={deleteHandler}
                />
                : null}
            <div className='mb-3 row'>
                <div className=' col-sm-12' style={{marginBottom:'15px'}}>
                    <textarea
                        placeholder="Enter Challenge body here..."
                        name="newsBody"
                        size={'small'}
                        style={{ height: '110px', width: '100%', marginTop: '10px',border:'1px solid rgb(118, 118, 118)' }}
                        required={true}
                        value={objectData.description}
                        onChange={(e) => inputChange(e, "body")}
                    />
                    <div id="newsBody" className="form-text text-danger">{message}</div>
                </div>

                <div className=' row' style={{marginBottom:'15px'}}>
                    <div className="text-center">
                        <button className="cred-btn" onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
            <div className=' row' style={{marginBottom:'15px'}}>
                <h3 style={{fontWeight:'300'}}>Challenges</h3>
                <div className='row mt-3'>

                    <div style={{ overflowX: 'auto' }}>
                        <table className='table credhub-table'>
                            <thead>
                                <tr>
                                    <th scope="col">S. No</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allData && allData.length > 0 ? allData.map((row, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{row.description}</td>
                                            <td> <button className='btn action-btn' onClick={e => saveHandler('edit', row)}>
                                                <i className='fa fa-edit' />
                                            </button>
                                                <button className='btn action-btn' onClick={e => saveHandler('delete', row.id)}>
                                                    <i className='fa fa-trash-o' />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                                    : <h4 style={{fontWeight:'300',padding:'0 5px'}}>No Data Found!!</h4>}
                            </tbody>
                        </table>
                    </div>
                    <PaginationPage
                        paginationHandlerNew={paginationHandlerNew}
                        totalCount={totalCount}
                        paginationHandler={paginationHandler}
                        pageNumber={pageNumber}
                        noOfRows={noOfRows}
                    />
                </div>
            </div>
            {
                alertState ?
                    <Alerts msg={msg}></Alerts> : ""
            }
        </div>
    )

}
export default Challenges;